var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconProject = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.46,
    height: 12.733,
    viewBox: "0 0 11.46 12.733",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_assignment_24px",
    d: "M13.187,2.273H10.525a1.9,1.9,0,0,0-3.591,0H4.273A1.277,1.277,0,0,0,3,3.547V12.46a1.277,1.277,0,0,0,1.273,1.273h8.913A1.277,1.277,0,0,0,14.46,12.46V3.547A1.277,1.277,0,0,0,13.187,2.273Zm-4.457,0a.637.637,0,1,1-.637.637A.639.639,0,0,1,8.73,2.273ZM10,11.187H5.547V9.913H10Zm1.91-2.547H5.547V7.367h6.367Zm0-2.547H5.547V4.82h6.367Z",
    transform: "translate(-3 -1)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconProject);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-project.f3854f03cd5ab06e203138e5ea37f7cf.svg";